/** Quebec R&D tax credits — CDAE / CDAEIA, CRIC. */
export const QUEBEC_RD_TASKS = [
  {
    id: 1,
    name: "Quebec eligibility",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm Quebec establishment and R&D activities", completed: false },
      { id: "1-2", name: "Determine applicable credit (CDAE, CDAEIA, CRIC)", completed: false },
      { id: "1-3", name: "Engage Quebec tax advisor if needed", completed: false },
    ],
  },
  {
    id: 2,
    name: "Technical & financial documentation",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Document eligible R&D projects (French if required)", completed: false },
      { id: "2-2", name: "Compile salary, subcontractor, and material costs", completed: false },
      { id: "2-3", name: "Prepare Form CO-1029 series schedules", completed: false },
    ],
  },
  {
    id: 3,
    name: "File & defend",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Submit with Quebec corporate tax return", completed: false },
      { id: "3-2", name: "Respond to RQ review or audit requests", completed: false },
    ],
  },
];
